/** Проверка на CORS ошибки. Они возникают только у разрабов из-за кэша браузером ендпоинтов */
export const isCorsError = (reason: unknown): boolean => {
  if (reason == null) return false

  const message =
    // eslint-disable-next-line no-nested-ternary
    typeof reason === "string"
      ? reason
      : // eslint-disable-next-line no-nested-ternary
      reason instanceof Error
      ? reason.message
      : typeof reason === "object" && "message" in reason
      ? String((reason as { message: unknown }).message)
      : String(reason)

  const normalized = message.toLowerCase()

  return (
    normalized.includes("cors") ||
    normalized.includes("access-control-allow-origin") ||
    normalized.includes("cross-origin request blocked") ||
    normalized.includes("blocked by cors policy") ||
    // Chrome/Safari: opaque cross-origin script error
    message.trim() === "Script error." ||
    message.trim() === "Script error"
  )
}
